/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * State the browser has been in this minute. It may be omitted, `Active` or `Inactive`
 */
export enum TemporaryTrackingState {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}
